'use client';

import type { CSSProperties, ReactNode } from 'react';
import { useSessionTweaks } from '../Csessionpage/sessionTweaks';
import { resolveInheritedSpanTertiaryTextStyle } from './inheritedSpanTertiaryTextStyle';

export interface InheritedSpanTertiaryTextProps {
  style?: CSSProperties;
  children: ReactNode;
}

export function InheritedSpanTertiaryText({
  style,
  children,
}: InheritedSpanTertiaryTextProps): ReactNode {
  const { inheritedSpanTertiaryTextVariant } = useSessionTweaks();
  return (
    <span
      style={resolveInheritedSpanTertiaryTextStyle({
        variant: inheritedSpanTertiaryTextVariant,
        underlineStyle: style,
      })}
      data-inherited-span-tertiary-text-variant={inheritedSpanTertiaryTextVariant}
    >
      {children}
    </span>
  );
}
